module.exports = __webpack_public_path__ + "media/images/countryrect/be-74f877de54dff6f307f5420a2e7f314d.svg";